<template>
  <Modal title="商品信息" width="980" :value="value" :mask-closable="false" @on-visible-change="onVisibleChange">
    <div class="toolbar">
      <Input v-model.trim="query.skuCode" clearable placeholder="产品编码" @on-enter="search" />
      <Input v-model.trim="query.skuName" clearable placeholder="产品名称" @on-enter="search" />
      <Input v-model.trim="query.skuBarCode" clearable placeholder="条码" @on-enter="search" />
      <Button type="primary" icon="ios-search" @click="search">查询</Button>
      <Button icon="md-add" @click="openAdd">新增</Button>
    </div>
    <CTable :columns="columns" :data="list" :total="total" :current="query.page" :page-size="query.pageSize" :show-page="true" @change="changePage" />

    <Modal :title="editData.id ? '编辑商品' : '新增商品'" width="560" :value="editModal" :mask-closable="false" @on-visible-change="onEditVisibleChange">
      <Form ref="editForm" :model="editData" :rules="rules" :label-width="100">
        <FormItem label="产品编码" prop="skuCode"><Input v-model.trim="editData.skuCode" /></FormItem>
        <FormItem label="产品名称" prop="skuName"><Input v-model.trim="editData.skuName" /></FormItem>
        <FormItem label="条码"><Input v-model.trim="editData.skuBarCode" /></FormItem>
      </Form>
      <div slot="footer"><Button @click="editModal = false">取消</Button><Button type="primary" :loading="saving" @click="saveProduct">保存</Button></div>
    </Modal>
  </Modal>
</template>

<script>
import CTable from '@/components/CTable'

export default {
  name: 'ProductInfoModal',
  components: {CTable},
  model: {prop: 'value', event: 'change'},
  props: {value: Boolean},
  data () {
    return {
      list: [],
      total: 0,
      saving: false,
      editModal: false,
      originalSkuCode: '',
      query: {page: 1, pageSize: 10, skuCode: '', skuName: '', skuBarCode: '', isView: 'Y'},
      editData: this.emptyProduct(),
      rules: {
        skuCode: [{required: true, message: '请输入产品编码', trigger: 'blur'}],
        skuName: [{required: true, message: '请输入产品名称', trigger: 'blur'}]
      },
      columns: [
        {title: '产品编码', key: 'skuCode', minWidth: 150},
        {title: '产品名称', key: 'skuName', minWidth: 220},
        {title: '条码', key: 'skuBarCode', minWidth: 140},
        {title: '操作', key: 'action', width: 150, render: (h, p) => h('div', [h('a', {on: {click: () => this.openEdit(p.row)}}, '编辑'), h('a', {style: {marginLeft: '12px', color: '#ed4014'}, on: {click: () => this.deleteProduct(p.row)}}, '删除')])}
      ]
    }
  },
  watch: {
    value (visible) {
      if (visible) this.loadData()
    }
  },
  methods: {
    emptyProduct () {
      return {id: null, skuCode: '', skuName: '', classCode: '', skuBarCode: '', offerPrice: '', isView: 'Y'}
    },
    onVisibleChange (visible) {
      if (this.value !== visible) this.$emit('change', visible)
    },
    search () {
      this.query.page = 1
      this.loadData()
    },
    changePage (page) {
      const nextPage = Number(page)
      this.query.page = Number.isFinite(nextPage) && nextPage > 0 ? nextPage : 1
      this.loadData()
    },
    loadData () {
      this.$fetch('SysSku/getList', this.query).then(res => {
        this.list = (res.data && res.data.list) || []
        this.total = Number(res.data && res.data.total) || 0
      })
    },
    openAdd () {
      this.editData = this.emptyProduct()
      this.originalSkuCode = ''
      this.editModal = true
    },
    openEdit (row) {
      this.editData = Object.assign(this.emptyProduct(), row)
      this.originalSkuCode = this.normalizeSkuCode(row.skuCode)
      this.editModal = true
    },
    onEditVisibleChange (visible) {
      if (this.editModal !== visible) this.editModal = visible
      if (!visible && this.$refs.editForm) this.$refs.editForm.resetFields()
    },
    normalizeSkuCode (value) {
      return String(value || '').trim().toLowerCase()
    },
    checkSkuCodeDuplicate () {
      const skuCode = this.normalizeSkuCode(this.editData.skuCode)
      if (!skuCode || skuCode === this.originalSkuCode) {
        return Promise.resolve(false)
      }
      // 这是保存前的即时提示；后端仍必须以数据库唯一约束作为最终防线。
      return this.$fetch('SysSku/getCodeName', {}).then(res => {
        const products = (res.data && res.data.list) || []
        return products.some(product => this.normalizeSkuCode(product.skuCode) === skuCode)
      })
    },
    saveProduct () {
      this.$refs.editForm.validate(valid => {
        if (!valid) return
        this.saving = true
        this.checkSkuCodeDuplicate()
          .then(duplicate => {
            if (duplicate) {
              this.$Message.error('产品编码已存在，保存失败')
              return null
            }
            return this.$fetch('SysSku/save', this.editData, 'POST').then(() => {
              this.$Message.success('保存成功')
              this.editModal = false
              this.loadData()
            })
          })
          .then(() => { this.saving = false }, () => { this.saving = false })
      })
    },
    deleteProduct (row) {
      this.$Modal.confirm({
        title: '删除商品',
        content: `<p>确认删除“${row.skuName}”吗？</p>`,
        onOk: () => this.$fetch('SysSku/del', {id: row.id}).then(() => {
          this.$Message.success('删除成功')
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped>
.toolbar { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; margin-bottom: 14px; }
.toolbar .ivu-input-wrapper { width: 180px; }
</style>
